(function ($) {
	'use strict';

	$.fn.filterTable = function () {

		this.each(function () {

			$('.js-filter-table-category, .js-filter-table-school, .js-filter-table-level, .js-filter-table-search', this).on('change keyup', function () {
				console.log('changed');

				var chosenCategory = $('.js-filter-table-category').val() + '',
					chosenSearch = $.trim($('.js-filter-table-search').val()),
					chosenSchool = $('.js-filter-table-school').val() + '',
					chosenLevel = $('.js-filter-table-level').val() + '';

				var isEven = false;
				$('.js-education-row').each(function () {
					var thisCategory = $(this).data('category') + '',
						thisSchool = $(this).data('school') + '',
						thisLevel = $(this).data('level') + '',
						thisText = $(this).text(),
						isHidden = false;

					// Category filter
					if (!(chosenCategory === thisCategory || chosenCategory === 'all')) {
						isHidden = true;
					}

					// School filter
					if (!(chosenSchool === thisSchool || chosenSchool === 'all')) {
						isHidden = true;
					}

					// Level filter
					if (!(chosenLevel === thisLevel || chosenLevel === 'all')) {
						isHidden = true;
					}

					// Search filter
					if (!isHidden && chosenSearch !== '') {
						if (thisText.toLowerCase().indexOf(chosenSearch.toLowerCase()) === -1) {
							isHidden = true;
						}
					}

					$(this).toggleClass('is-hidden', isHidden).toggleClass('is-even', isEven);

					if (!isHidden) {
						isEven = !isEven;
					}

				});

			});


		});


	};

	$(function () {

		$('.js-filter-table').filterTable();

	});


})(jQuery);